import React, { memo } from 'react';

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  Tooltip,
} from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

const hiddenControlStyles = { display: 'none' };
const hiddenControlLabelStyles = { marginLeft: 0, height: '38px' };

const RadioGroupCDS = ({
  name,
  label = '',
  value = '',
  options,
  onChange = _.noop,
  disabled = false,
  error = false,
  helperText = '',
  row = false,
  required = false,
  dataTestId = '',
  labelPlacement = 'end',
  className = '',
  hideControl = false,
}) => {
  const formattedValue = value?.toString?.() ?? '';

  return (
    <FormControl className={className} disabled={disabled} error={error}>
      {!!label && (
        <FormLabel error={error} required={required}>
          {label}
        </FormLabel>
      )}

      {!!options?.length && (
        <MuiRadioGroup
          data-testid={dataTestId}
          name={name}
          row={row}
          value={formattedValue}
          onChange={onChange}
        >
          {options.map(
            ({
              value: optionValue,
              label: optionLabel,
              name: optionName,
              disabled: optionDisabled,
              tooltip,
            }) => {
              const control = (
                <FormControlLabel
                  control={
                    <Radio disabled={disabled} sx={hideControl ? hiddenControlStyles : null} />
                  }
                  disabled={disabled || optionDisabled}
                  key={optionValue}
                  label={optionLabel || optionName}
                  labelPlacement={labelPlacement}
                  sx={hideControl ? hiddenControlLabelStyles : null}
                  value={optionValue}
                />
              );

              if (tooltip) {
                return (
                  <Tooltip key={optionValue} title={tooltip}>
                    <span>{control}</span>
                  </Tooltip>
                );
              }

              return control;
            },
          )}
        </MuiRadioGroup>
      )}

      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

RadioGroupCDS.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node,
      name: PropTypes.string,
      disabled: PropTypes.bool,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  row: PropTypes.bool,
  required: PropTypes.bool,
  dataTestId: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),
  className: PropTypes.string,
  hideControl: PropTypes.bool,
  onChange: PropTypes.func,
};

export default memo(RadioGroupCDS);
